import usePDFTheme from '@/utils/hooks/usePDFTheme';
import { Page, Text, View } from '@react-pdf/renderer';
import React from 'react';

interface PortfolioStatementLayoutProps {
    label: string;
    children: React.ReactNode;
}

const PortfolioStatementLayout = ({ label, children }: PortfolioStatementLayoutProps) => {
    const pdfTheme = usePDFTheme();
    const { base, palette } = pdfTheme;

    return (
        <Page size="A4" style={base.page}>
            {children}
            <View style={base.footer} fixed>
                <Text style={base.footerText}>GCEX GROUP · {label.toUpperCase()}</Text>
                <Text
                    style={[base.footerText]}
                    render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
                />
            </View>
        </Page>
    );
};

export default PortfolioStatementLayout;
